import { gql } from '@apollo/client'
import { userErrorFragment } from '~/graphql/fragments/userError'

export const UNLINK_FACEBOOK_ACCOUNT = gql`
  mutation unlinkFacebookAccount {
    unlinkFacebookAccount {
      user {
        id
        facebookAccount {
          friendsCount
        }
      }
      errors {
        ...userError
      }
    }
  }

  ${userErrorFragment}
`
